import * as React from 'react';
import { cn } from '../../lib/cn';

export type SwitchProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> & {
  checked: boolean;
  onCheckedChange?: (checked: boolean) => void;
};

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ checked, onCheckedChange, className, disabled, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => {
        if (disabled) return;
        onCheckedChange?.(!checked);
      }}
      className={cn(
        'inline-flex h-5 w-9 shrink-0 items-center rounded-full border-2 transition-colors',
        checked
          ? 'border-transparent bg-[hsl(var(--ui-primary))]'
          : 'border-[hsl(var(--ui-border))] bg-[hsl(var(--ui-muted))]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ui-ring))] disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <span
        className={cn(
          'mx-px h-3.5 w-3.5 rounded-full shadow-sm transition-transform',
          checked
            ? 'translate-x-4 bg-[hsl(var(--ui-primary-foreground))]'
            : 'translate-x-0 bg-[hsl(var(--ui-card))]',
          'ring-1 ring-[hsl(var(--ui-border))]/60'
        )}
      />
    </button>
  )
);

Switch.displayName = 'Switch';
